import React, { Fragment } from 'react';
import '../../_assets/css/file.css';
import './style.css';

import { Form } from "react-bootstrap";
import axios from 'axios';
import ReactDatatable from '@ashvin27/react-datatable';
import { Card, CardBody, Col, Button } from 'reactstrap';
import { baseURL } from '../../_helpers';
import { TOKEN, ROLE } from '../../_helpers/exports';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
// import { Customers } from './customer_view';
import Input from 'react-phone-number-input/input'
import { Link } from 'react-router-dom';
import Alert from '../../shared/components/Alert';
// import CreateAddress from '../Address/createCustomerAddress';
import * as moment from 'moment';
import Modal from 'react-modal';
import { MDBCloseIcon } from "mdbreact"
import RefreshIcon from 'mdi-react/RefreshCircleIcon';
import { logRoles } from '@testing-library/react';

import Select from 'react-select';

class SellFloat extends React.Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
    };
    constructor(props) {
        super(props)
        this.handleFromDateUpdate = this.handleFromDateUpdate.bind(this);
        this.handleToDateUpdate = this.handleToDateUpdate.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onSubmitCreate = this.onSubmitCreate.bind(this);
        this.onSubmitModify = this.onSubmitModify.bind(this);
        this.onSubmitFloat = this.onSubmitFloat.bind(this);
        this.contentBack = this.contentBack.bind(this);

        this.state = {
            showComponent: false,
            hideComponent: true,
            moreinfo: false,
            isLoading: false,
            isShowError: false,
            isOpenCreate: false,
            isOpen: false,
            isOpenFloat: true,
            isOpenModify: false,
            startDate: new Date(),
            endDate: new Date(),
            statusMessage: '',
            showError: false,


        }
        this.client = [
            {
                label: 'True',
                value: true
            },
            {
                label: 'False',
                value: false
            },
        ];

        this.columns = [
            {
                key: "id",
                TrOnlyClassName: 'tsc',
                text: "Client id",
                className: "tsc",
                align: "left"
            },
            {
                key: "name",
                TrOnlyClassName: 'tsc',
                text: "Client Name",
                className: "tsc",
                align: "left"
            },
            {
                key: "action",
                text: "Options",
                TrOnlyClassName: 'cell',
                width: 250,
                sortable: false,
                cell: record => {
                    return (
                        <Fragment className="center"  >
                            <div>
                                {record.customer_verification == true ?
                                    <button className="btn btn-success  btn-sm"
                                        title="View"
                                        style={
                                            { marginRight: '10px' }}
                                        onClick={
                                            () => { this.toggleModal(record) }} >
                                        Verify
                                              </button>
                                    : null}
                                <button className="btn btn-primary  btn-sm"
                                    title="View"
                                    style={
                                        { marginRight: '10px' }}
                                    onClick={
                                        () => { this.toggleModalFloat(record) }} >
                                    Sell Float
                                       </button>
                            </div>
                        </Fragment >
                    );
                }
            },

        ]
        this.config = {
            key_column: "tsc",
            length_menu: [10, 20, 50],
            show_filter: false,
            show_pagination: true,
            pagination: 'advance',
            page_size: 10,
            show_length_menu: true,
            language: {
                loading_text: "Please be patient while data loads...",
                filter: "Search...",
                no_data_text: "No data was found",
                pagination: {
                    next: <span>&#9658;</span>,
                    previous: <span>&#9668;</span>
                    // next
                    // previous
                }
            }
        }
    }

    handleFromDateUpdate(date) {
        this.setState({
            startDate: date.date
        })
    }
    handleToDateUpdate(date) {
        this.setState({
            endDate: date.date
        })
    }


    componentDidMount() {
        let formData = {
            "session_id": TOKEN
        }
        this.setState({
            isLoading2: true
        })
        let url = baseURL + "get_clients"
        axios.all([
            axios.post(url, formData),
        ]).then(axios.spread((clientResponse) => {

            this.setState({
                Client: clientResponse.data.clients,
                isLoading2: false
            })
        })).catch(error => {
            console.log('bayoo', error.response)
        })
    }

    Client() {
        // alert(JSON.stringify(this.state.client))
        return (
            this.state.Client &&
            (this.state.Client.length > 0 || this.state.Client.length === 0) &&
            this.state.Client.map((countyItem, i) => ({
                label: countyItem.name,
                customer_verification: countyItem.customer_verification,
                value: countyItem.id,
            }))
        );
    }

    onSelectChangesBank = value => {

        this.setState(
            {
                customer_verification: value.customer_verification.toString(),
                client_name: value.label.toString(),
                client_id: value.value.toString()
            }, function () {
                // alert( this.state.client_name, this.state.client_id)
            });
        if (value.customer_verification.toString() === "false") {
            this.setState(
                {
                    isOpenFloat: false,
                    isOpen: true
                });
        }
    };


    contentBack() {
        this.setState(
            {

                isOpenFloat: true,
                isOpen: false
            });
    }


    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    toggleModalModify(record) {
        this.setState({
            isOpenModify: true,
            client_id: record.id,
            customer_verification_endpoint: record.customer_verification_endpoint
        });
    };
    toggleModal(record) {
        this.setState({
            client_id: record.id,
            isOpen: true,
        });
    };

    toggleModalCreate = e => {
        this.setState({
            isOpenCreate: true,
        });
    };
    // toggleModalFloat = e => {
    //     this.setState({
    //         isOpenFloat: true,
    //     });
    // };

    toggleModalFloat(record) {
        this.setState({
            isOpenFloat: true,
            client_id: record.id
        });
    };

    onSubmitCreate(e) {
        e.preventDefault();
        let formData = {
            "session_id": TOKEN,
            "name": this.state.client_name,
            "renconciliation_endpoint": "http://10.10.10.10:1001/reconcile"
        }

        this.setState({ isLoading: true });
        axios.post(baseURL + 'add_client', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': TOKEN
            },
        }).then((response) => {
            console.log('bayoo', response.data)
            if (response.data.code === "0000") {
                this.setState({ statusMessage: response.data.message, showError: false, isShowError: true, isLoading: false });
                window.scrollTo(0, 0)
                window.setTimeout(() => {
                    this.setState({ isShowError: false });
                    this.closeModalCreate(e)

                    this.getData();
                }, 2000);
            } else {
                this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, isLoading: false });

                window.setTimeout(() => {
                    this.setState({
                        isLoading: false,
                        isShowError: false,
                        statusMessage: "",
                        showError: false
                    });
                }, 2000);
            }
        }).catch((error) => {
            console.log('bayoo', error)
            this.setState({
                statusMessage: error.response === undefined ? "Check your Internet" : error.response.data.message, showError: true, isShowError: false, isLoading: false
            });
            window.setTimeout(() => {
                this.setState({
                    isLoading: false,
                    isShowError: false,
                    showError: false,
                    errorShow: false
                });
            }, 2000);
        })
    }


    onSubmitDisabled(record) {

        let formData = {
            "session_id": TOKEN,
            "customer_verification_endpoint": record.customer_verification_endpoint,
            "client_id": record.id,
            "enabled": false
        }

        // alert(JSON.stringify(formData))

        this.setState({ isLoading: true });
        axios.post(baseURL + 'modify_client_details', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': TOKEN
            },
        }).then((response) => {
            console.log('bayoo', response.data)
            if (response.data.code === "0000") {
                this.setState({ statusMessage: response.data.message, showError: false, isShowError: true, isLoading: false });
                window.scrollTo(0, 0)
                window.setTimeout(() => {
                    this.setState({ isShowError: false });
                    this.getData();
                }, 2000);
            } else {
                this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, isLoading: false });
                window.setTimeout(() => {
                    this.setState({
                        isLoading: false,
                        isShowError: false,
                        statusMessage: "",
                        showError: false
                    });
                }, 2000);
            }
        }).catch((error) => {
            console.log('bayoo', error)
            this.setState({
                statusMessage: error.response === undefined ? "Check your Internet" : error.response.data.message, showError: true, isShowError: false, isLoading: false
            });
            window.setTimeout(() => {
                this.setState({
                    isLoading: false,
                    isShowError: false,
                    showError: false,
                    errorShow: false
                });
            }, 2000);
        })
    }



    onSubmitModify(record) {

        let formData = {
            "session_id": TOKEN,
            "customer_verification_endpoint": record.customer_verification_endpoint,
            "client_id": record.id,
            "enabled": true
        }

        // alert(JSON.stringify(formData))

        this.setState({ isLoading: true });
        axios.post(baseURL + 'modify_client_details', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': TOKEN
            },
        }).then((response) => {
            console.log('bayoo', response.data)
            if (response.data.code === "0000") {
                this.setState({ statusMessage: response.data.message, showError: false, isShowError: true, isLoading: false });
                window.scrollTo(0, 0)
                window.setTimeout(() => {
                    this.setState({ isShowError: false });
                    this.getData();
                }, 2000);
            } else {
                this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, isLoading: false });
                window.setTimeout(() => {
                    this.setState({
                        isLoading: false,
                        isShowError: false,
                        statusMessage: "",
                        showError: false
                    });
                }, 2000);
            }
        }).catch((error) => {
            console.log('bayoo', error)
            this.setState({
                statusMessage: error.response === undefined ? "Check your Internet" : error.response.data.message, showError: true, isShowError: false, isLoading: false
            });
            window.setTimeout(() => {
                this.setState({
                    isLoading: false,
                    isShowError: false,
                    showError: false,
                    errorShow: false
                });
            }, 2000);
        })
    }

    onSubmit(e) {
        e.preventDefault();

        let formData = {
            "session_id": TOKEN,
            "client_id": this.state.client_id,
            "customer_id": this.state.customer_id,
        }


        alert(JSON.stringify(formData))

        this.setState({ isLoading: true });
        axios.post(baseURL + 'verify_customer', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': TOKEN
            },
        }).then((response) => {
            console.log('bayoo', response.data)
            if (response.data.code === "0000") {
                this.setState({ statusMessage: response.data.message, showError: false, isShowError: true, isLoading: false });
                window.scrollTo(0, 0)
                window.setTimeout(() => {
                    this.setState({ isShowError: false });
                    this.contentBack()
                }, 2000);
            } else {
                this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, isLoading: false });

                window.setTimeout(() => {
                    this.setState({
                        isLoading: false,
                        isShowError: false,
                        statusMessage: "",
                        showError: false
                    });
                }, 2000);
            }
        }).catch((error) => {
            console.log('bayoo', error)
            this.setState({
                statusMessage: error.response === undefined ? "Check your Internet" : error.response.data.message, showError: true, isShowError: false, isLoading: false
            });
            window.setTimeout(() => {
                this.setState({
                    isLoading: false,
                    isShowError: false,
                    showError: false,
                    errorShow: false
                });
            }, 2000);
        })
    }



    onSubmitFloat(e) {
        e.preventDefault();

        let formData = {
            "session_id": TOKEN,
            "client_id": this.state.client_id,
            "customer_id": this.state.customer_id,
            "amount": this.state.amount

        }

        this.setState({ isLoading: true });
        axios.post(baseURL + 'sell_float', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': TOKEN
            },
        }).then((response) => {
            console.log('bayoo', response.data)
            if (response.data.code === "0000") {
                this.setState({ statusMessage: response.data.message, showError: false, isShowError: true, isLoading: false });
                window.scrollTo(0, 0)
                window.setTimeout(() => {
                    this.setState({ isShowError: false, customer_verification: false, message: "", customer_id: "" });
                }, 2000);
            } else {
                this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, isLoading: false });

                window.setTimeout(() => {
                    this.setState({
                        isLoading: false,
                        isShowError: false,
                        statusMessage: "",
                        showError: false
                    });
                }, 2000);
            }
        }).catch((error) => {
            console.log('bayoo', error)
            this.setState({
                statusMessage: error.response === undefined ? "Check your Internet" : error.response.data.message, showError: true, isShowError: false, isLoading: false
            });
            window.setTimeout(() => {
                this.setState({
                    isLoading: false,
                    isShowError: false,
                    showError: false,
                    errorShow: false
                });
            }, 2000);
        })
    }

    closeModalCreate = e => {
        this.setState({
            isOpenCreate: false,
        });
    };
    closeModalFloat = e => {
        this.setState({
            isOpenFloat: true,
        });
    };

    closeModalModify = e => {
        this.setState({
            isOpenModify: false,
        });
    };
    closeModal = e => {
        this.setState({
            isOpen: false,
        });
    };


    onSelectChange = value => {
        this.setState(
            {
                enabled: value.value
            });

    };
    render() {
        // alert(ROLE)

        return (
            <div>


                <Modal
                    isOpen={this.state.isOpen}
                    // onRequestClose={e => {
                    //     this.closeModal(e);
                    // }}
                    contentLabel="My dialog"
                    className="mymodalclient"
                    onAfterOpen={() => {
                        document.body.style.overflow = 'hidden';
                    }}
                    onAfterClose={() => {
                        document.body.removeAttribute('style');
                    }}
                    overlayClassName="myoverlay"
                    closeTimeoutMS={500}
                >
                    <h4><b>Verify Customer</b></h4><br />

                    {this.state.showError ? <div >

                        <Alert color="danger" className="alert--colored" icon>
                            <p><span className="bold-text">{this.state.statusMessage}</span>
                            </p>
                        </Alert>


                    </div> : null}

                    {this.state.isShowError ? (
                        <div>

                            <Alert color="success" className="alert--colored" icon>
                                <p><span className="bold-text">{this.state.statusMessage}</span>
                                </p>
                            </Alert>
                        </div>
                    ) : null}
                    <br></br>

                    <form className="form" onSubmit={this.onSubmit}>
                        <div className="col-md-12">

                            <div className="form-group">
                                <input id="input" type="text" className="form-control"
                                    name="customer_id" placeholder='Enter Customer ID'
                                    value={this.state.customer_id} onChange={this.handleChange} />

                            </div>
                        </div>
                        <br />

                        <div className="col-md-6 offset-2">
                            <button
                                type="submit"
                                onClick={this.check2}
                                className="pull-right btn btn-primary btn-sm">
                                {this.state.isLoading ? "Please Wait..." : "Verify"}
                            </button>
                        </div>
                        <div className="col-md-6">
                            <br></br>
                            <p>Go back? <a href="#" onClick={this.contentBack}>Click here</a></p>
                        </div>
                    </form>
                </Modal>


                <Modal
                    isOpen={this.state.isOpenFloat}
                    onRequestClose={e => {
                        this.closeModalFloat(e);
                    }}
                    contentLabel="My dialog"
                    className="mymodalclient"
                    onAfterOpen={() => {
                        document.body.style.overflow = 'hidden';
                    }}
                    onAfterClose={() => {
                        document.body.removeAttribute('style');
                    }}
                    overlayClassName="myoverlay"
                    closeTimeoutMS={500}
                >
                    {/* <MDBCloseIcon onClick={this.closeModalFloat} /> */}
                    <h4><b>Sell Float</b></h4><br />
                    {this.state.showError ? <div >
                        <Alert color="danger" className="alert--colored" icon>
                            <p><span className="bold-text">{this.state.statusMessage}</span>
                            </p>
                        </Alert>
                    </div> : null}
                    {this.state.isShowError ? (
                        <div>
                            <Alert color="success" className="alert--colored" icon>
                                <p><span className="bold-text">{this.state.statusMessage}</span>
                                </p>
                            </Alert>
                        </div>
                    ) : null}
                    <br></br>
                    <form className="form" onSubmit={this.onSubmitFloat}>
                        <div className="col-md-12">
                            <div className="form-group">
                                <input id="input" type="text" className="form-control"
                                    name="customer_id" placeholder='Customer ID'
                                    value={this.state.customer_id} onChange={this.handleChange} />
                            </div>
                            <br />
                        </div>


                        <div className="col-md-12">
                            <div className="form-group">

                                <Select
                                    isClearable
                                    id="input"
                                    options={this.Client()}
                                    // onInputChange={this.loadOptions}
                                    placeholder="Search Client"
                                    autosize={true}
                                    onChange={this.onSelectChangesBank}
                                    isLoading={this.state.isLoading2}
                                    // noOptionsMessage={() => 'nothing found'}
                                    // loadingMessage={() => 'searching...'}   //minor type-O here
                                    menuPortalTarget={document.body}
                                    name="namffe"
                                />
                            </div>
                        </div>
                        {this.state.customer_verification === "true" ?
                            <div className="col-md-12">
                                <br />
                                <div className="form-group">
                                    <input id="input" type="number" className="form-control"
                                        name="amount" placeholder='Amount'
                                        value={this.state.amount} onChange={this.handleChange} />
                                </div>
                            </div>
                            : null}
                        <div className="col-md-6 offset-2">
                            <br />
                            <button
                                type="submit"
                                onClick={this.check2}
                                className="pull-right btn btn-primary btn-sm">
                                {this.state.isLoading ? "Please Wait..." : "Submit"}
                            </button>
                        </div>
                    </form>
                </Modal>
                {/* {this.state.showError ? <div >

                    <Alert color="danger" className="alert--colored" icon>
                        <p><span className="bold-text">{this.state.statusMessage}</span>
                        </p>
                    </Alert>
                </div> : null}<br></br>

                {this.state.isShowError ? (
                    <div>
                        <Alert color="success" className="alert--colored" icon>
                            <p><span className="bold-text">{this.state.statusMessage}</span>
                            </p>
                        </Alert>
                    </div>
                ) : null} */}

            </div>
        )
    }
}
export default withTranslation('common')(SellFloat);
